import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, IconButton, MenuItem, Paper, Popper, ClickAwayListener, Typography, Button } from "@mui/material";
import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gateway } from "../gateway";
import { resetUser } from "../redux/features/userStateSlice";
import { performSignOut } from "../utils/performSignOut";
import { BaseDialog } from "./common/BaseDialog";
import { colors } from "./ui/colors";

const styles = {
  titleSx: {
    textAlign: "center",
    color: "blue",
  },
  actionSx: {
    justifyContent: "center",
  },
  btnDialogSx: {
    backgroundColor: "#4CAF50",
    color: "white",
    "&:hover": { backgroundColor: "#4CAF50" },
    margin: "0 8px",
  },
  btnDialogConfirm: {
    backgroundColor: "#B0BEC5",
    color: "white",
    "&:hover": { backgroundColor: "#B0BEC5" },
    margin: "0 8px",
  },
};

export const AccountDeactivation = ({ onDeactivate, buttonSx = {} }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [openDeactivationDialog, setOpenDeactivationDialog] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  const anchorRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOff = async () => {
    await performSignOut();
    dispatch(resetUser());
    navigate("/signin");
  };

  const token = sessionStorage.getItem("token");

  const handleDeactivationEmail = async () => {
    try {
      const res = await gateway.get("users/send-delete/self", {
        headers: { Authorization: token },
      });

      if (res?.data?.status === 200) {
        handleSignOff();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          disableElevation
          onClick={() => {
            setOpenMenu(false);
            setOpenDeactivationDialog(true);
          }}
          sx={{
            bgcolor: colors.orange.base,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "8px",
            boxShadow: "none",
            p: 2,
            "&:hover": { bgcolor: "#ea580c", boxShadow: "none" },
            ...buttonSx,
          }}
        >
          Deactivate Account
        </Button>
      </Box>

      <BaseDialog
        openState={openDeactivationDialog}
        setOpenState={() => setOpenDeactivationDialog(false)}
        title="ACCOUNT DEACTIVATION"
        titleSx={styles.titleSx}
        content={
          <>
            <Typography sx={{ textAlign: "center", color: "var(--fx-surface-text, #0F172A)" }}>
              Before proceeding, we would like to remind you that if you deactivate your account, it will require manual reactivation by our support
              team.
            </Typography>
            <Typography sx={{ fontWeight: "bold", textAlign: "center", mt: 2 }}>Are you sure you want to continue?</Typography>
          </>
        }
        actionSx={styles.actionSx}
        actions={[
          {
            label: "CANCEL",
            onClick: () => setOpenDeactivationDialog(false),
            style: styles.btnDialogSx,
          },
          {
            label: "CONTINUE",
            onClick: () => {
              setOpenDeactivationDialog(false);
              setOpenConfirmationDialog(true);
            },
            style: styles.btnDialogConfirm,
          },
        ]}
      />

      <BaseDialog
        openState={openConfirmationDialog}
        setOpenState={() => setOpenConfirmationDialog(false)}
        title="We are sorry to see you go!"
        titleSx={styles.titleSx}
        content={
          <>
            <Typography sx={{ textAlign: "center" }}>
              In order to proceed with deactivation, we've sent you an email for identity verification.
            </Typography>
            <Typography sx={{ textAlign: "center", mt: 2 }}>Please verify and follow the instructions sent.</Typography>
          </>
        }
        actionSx={styles.actionSx}
        actions={[
          {
            label: "OK",
            autoFocus: true,
            onClick: () => {
              setOpenConfirmationDialog(false);
              handleDeactivationEmail();
            },
            style: styles.btnDialogSx,
          },
        ]}
      />
    </>
  );
};
